
import Vue, { PropType } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export default Vue.extend({
  name: 'VerticalList',
  functional: true,
  props: {
    type: {
      type: String as PropType<'dotted' | 'ordered' | null>,
      default: 'dotted' as const,
      validator: (val) => val === 'dotted' || val === 'ordered' || val === null,
    },
  },
  render(h, { props, data, children }) {
    return h(
      props.type === 'dotted' || props.type === null ? 'ul' : 'ol',
      mergeData(data, {
        class: {
          'slds-list_dotted': props.type === 'dotted',
          'slds-list_ordered': props.type === 'ordered',
        },
      }),
      children
    );
  },
});
